import React, { useEffect, useState } from 'react'
import { Toast } from './../UI/toast/Toast'
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes'
import { fetchProperties } from '../../helpers/api/condominium'
import PageHeader from '../common/PageHeader'
import handleErrorMessage from '../../helpers/errors/handleErrorMessage'
import withRedirect from '../../helpers/hoc/withRedirect'
import { useParams } from 'react-router'
import { fetchOneAliquot, updateAliquot } from '../../helpers/api/finance'
import useSWRFetchPagination from '../../helpers/hooks/useSWRFetchPagination'
import CreateAliquotForm from './CreateAliquotForm'
import { PreloadState } from '../UI/preloading/PreloadState'
import SupportLink from '../root/support/components/SupportLink'
import { useSelector } from 'react-redux'
import useModuleBase from "../../helpers/hooks/useModuleBase";

const EditAliquot = ({ setRedirectUrl, setRedirect }) => {

    const moduleBase = useModuleBase();

    const { id, aliquotId } = useParams();
    const {selectedCondominium} = useSelector(state => state.condominium);

    const [aliquot, setAliquot] = useState(null);
    const [loadingAliquot, setLoadingAliquot] = useState(true);

    const [params] =useState({
        condominiumId: selectedCondominium
    })

    const { data, meta, handler: { nextPage, previousPage, perPage, goToPage } } = useSWRFetchPagination(fetchProperties, params);

    useEffect(() => {
        if (aliquotId) {
            (async () => {
                try {
                    const { data } = await fetchOneAliquot(aliquotId);
                    setAliquot(data);
                } catch (error) {
                    handleErrorMessage(error);
                } finally {
                    setLoadingAliquot(false);
                }
            })()
        }
    }, [aliquotId])

    const update = async values => {
        try {
            const { code, warning } = await updateAliquot(aliquotId, values);

            if (code === SUCCESS_RESPONSE.SUCCESFUL) {
                setRedirectUrl(`/dashboard/${moduleBase}/${id}/aliquots`);
                setRedirect(true);
                Toast.fire({
                    type: 'success',
                    title: `Alícuota actualizada exitosamente.`,
                });
                if (warning) {
                    Toast.fire({
                        type: 'warning',
                        title: warning,
                        timer: 8000,
                    });
                }
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    return <>
        <PageHeader
            title="Editar alícuota"
            titleTag="h2"
            description="Edita una alícuota de un propietario de tu condominio."
            className="mb-3"
            col={{ lg: 9 }}
        >
            <SupportLink />
        </PageHeader>
        <PreloadState loading={loadingAliquot}>
            <CreateAliquotForm handleSubmitData={update} handler={{ nextPage, previousPage, perPage, goToPage, meta }} properties={data} aliquot={aliquot} />
        </PreloadState>
    </>
}

export default withRedirect(EditAliquot);